/**
 * Mobile header navigation - hamburger menu & megamenu nav links
 * Fixes tap responsiveness and prevents unwanted redirects on dropdown links
 */
(function () {
  'use strict';

  const OVERLAY_CLASSES = ['show-search', 'show-filters', 'show-minicart'];
  const MOBILE_BREAKPOINT = 768;

  /**
   * Checks if the viewport is at or below the mobile breakpoint.
   * @returns {boolean} True if viewport width <= MOBILE_BREAKPOINT (768px)
   */
  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function clearOverlays() {
    OVERLAY_CLASSES.forEach(function (cls) {
      document.body.classList.remove(cls);
    });
  }

  /**
   * Initializes the hamburger menu toggle. Attaches a click handler that
   * opens/closes the mobile sub-nav overlay and shows the first nav panel.
   */
  function initHamburger() {
    const hamburger = document.querySelector('.header--hamburger');
    if (!hamburger) return;

    function handleHamburgerClick(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const nav = document.querySelector('nav');
      const navWrapper = document.querySelector('nav .nav--wrapper');

      if (document.body.classList.contains('show-sub-nav')) {
        document.body.classList.remove('show-sub-nav');
        if (nav) nav.removeAttribute('data-sub-nav');
      } else {
        clearOverlays();
        document.body.classList.add('show-sub-nav');
        if (nav && navWrapper) {
          const firstLink = navWrapper.querySelector('.nav--link');
          const index = firstLink
            ? Array.from(navWrapper.querySelectorAll('.nav--link')).indexOf(firstLink) + 1
            : 1;
          nav.setAttribute('data-sub-nav', String(index));
        }
      }
    }

    hamburger.addEventListener('click', handleHamburgerClick, { passive: false });
  }

  /**
   * Initializes mobile nav link handlers. On mobile, prevents dropdown links
   * (with data-turbolinks) from navigating; instead opens their sub-nav panel.
   */
  function initMobileNavLinks() {
    const nav = document.querySelector('nav');
    const navWrapper = document.querySelector('nav .nav--wrapper');
    if (!nav || !navWrapper) return;

    navWrapper.addEventListener(
      'click',
      function (e) {
        const link = e.target.closest('.nav--link');
        if (!link || !isMobile()) return;

        if (link.getAttribute('data-turbolinks')) {
          e.preventDefault();
          e.stopImmediatePropagation();

          const links = navWrapper.querySelectorAll('.nav--link');
          const index = Array.from(links).indexOf(link) + 1;

          clearOverlays();
          document.body.classList.add('show-sub-nav');
          nav.setAttribute('data-sub-nav', String(index));
        }
      },
      true
    );
  }

  /**
   * Submenu back control: returns to the first top-level panel (data-sub-nav="1").
   */
  function initSubNavBack() {
    const nav = document.querySelector('nav');
    if (!nav) return;

    nav.addEventListener(
      'click',
      function (e) {
        const btn = e.target.closest('.sub-nav--back');
        if (!btn || !isMobile()) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        nav.setAttribute('data-sub-nav', '1');
      },
      true
    );
  }

  function init() {
    initHamburger();
    initMobileNavLinks();
    initSubNavBack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('turbolinks:load', init);
})();
